import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useMoldContext() {
  const { molds } = useContext<GlobalContextType>(GlobalContext);
  return molds;
}
